import { type Surah } from './SurahCard'
import { BookOpen } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface SurahHeaderProps {
  surah: Surah
}

export default function SurahHeader({ surah }: SurahHeaderProps) {
  const { t } = useTranslation()

  return (
    <div className="bg-gradient-to-br from-primary-50 to-primary-100 dark:from-primary-900/30 dark:to-primary-800/30 rounded-lg p-6 mb-6">
      <div className="flex items-start gap-4">
        <div className="w-16 h-16 rounded-lg bg-primary-600 dark:bg-primary-500 text-white flex items-center justify-center font-bold text-2xl flex-shrink-0">
          {surah.number}
        </div>
        <div className="flex-1">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-2">{surah.name}</h1>
          <p className="text-lg text-gray-700 dark:text-gray-300 mb-3">{surah.nameEn}</p>
          <div className="flex flex-wrap gap-4 text-sm text-gray-600 dark:text-gray-400">
            <div className="flex items-center gap-2">
              <BookOpen className="w-4 h-4" />
              <span>{surah.ayahs} {t('quran.header.ayahs', 'آية')}</span>
            </div>
            <span>{t('quran.header.juz', 'جزء')} {surah.juz}</span>
            <span>{t('quran.header.revelationOrder', 'ترتيب النزول')}: {surah.revelationOrder}</span>
          </div>
        </div>
      </div>
    </div>
  )
}


